module.exports = __webpack_public_path__ + "Roboto-Regular.5673da52c98bb6cb33ad.ttf";


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/assets/font/Roboto-Regular.ttf
// module id = ../../../../../src/assets/font/Roboto-Regular.ttf
// module chunks = styles